export class AdminNote {
    adminNoteId: number;
    detail: string;
    assignedUserId: string;
    createdUsername: string;
    createdDate: Date;

    constructor(props?: { [key in keyof AdminNote]?: AdminNote[key] }) {
        Object.assign(this, props);
    }
}